<script>
	import { user, step, tos, UserLoading, UserValid, Errors } from '../store.js'
	import { postUser } from '../service.js'
	import LoadingButton from '../components/LoadingButton.svelte';
	import InputField from '../components/Input.svelte';
	import Checkbox from '../components/Checkbox.svelte';
	
	const forward = async () => {
		if ($tos){
			try {
				await postUser()
				if ($UserValid){
					step.set(3)
				}
			} catch (err) {
				console.log(err)
			}
		}
	}

</script>

<div class="content">
	<h2>Start your free MODsense trial now</h2>
	<p>We provide free access to our web-based data management dashboard, without submission of payment details.</p>
	<InputField bind:value="{$user.first_name}" error="{$Errors['first name']}" placeholder={"First Name"}/>
	<InputField bind:value="{$user.last_name}" error="{$Errors['last name']}" placeholder={"Last Name"}/>
	<InputField bind:value="{$user.email}" error="{$Errors['email']}" placeholder={"Email"}/>
	<Checkbox bind:checked="{$tos}" >
		I agree to the <a href="./assets/Modum MODsense Trial Kit Terms and Conditions.pdf" target="_blank">Terms of Service</a> and <a href="./assets/Modum SaaS Privacy Declaration.pdf" target="_blank">Privacy Policy.</a>
	</Checkbox>

	{#if !!$Errors.user }
		<span class="error">{$Errors.user}</span>
	{/if}

	<LoadingButton disabled="{!$tos || $user.first_name.length === 0 || $user.last_name.length === 0 || $user.email.length === 0 ? true : false }" clickEvent="{() => forward()}" loading="{$UserLoading}" >
		Register
	</LoadingButton>

</div>

<style lang="scss">
	@import '../scss/variables.scss';
	a {
		color: $medium-grey;
		text-decoration: underline;
	}
</style>